import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Reusable component to display ENTRA authentication status and user details
 */
const AuthenticationStatus = ({ isAuthenticated, email, name, accountId, environment }) => {
  return (
    <Card className="mb-5">
      <Card.Header className="card-header-action bg-info-subtle">
        <h5 className="text-info">
          Authentication Status
        </h5>
        <small>Microsoft Entra ID (MSAL)</small>
      </Card.Header>

      <Card.Body className="justify-content-start">
        {isAuthenticated ? (
          <>
            <h6>
              <span style={{ color: 'green', marginRight: '10px' }}>✔</span>
              User is <strong>AUTHENTICATED</strong>
            </h6>
            <div style={{ marginLeft: '30px', marginTop: '10px' }}>
              <div style={{ color: 'green' }}>
                <small><strong>Email:</strong> {email}</small>
              </div>
              <div style={{ color: 'green' }}>
                <small><strong>Name:</strong> {name || 'Not available'}</small>
              </div>
              <div style={{ color: 'green' }}>
                <small><strong>Account ID:</strong> {accountId}</small>
              </div>
              <div style={{ color: 'green' }}>
                <small><strong>Environment:</strong> {environment}</small>
              </div>
            </div>
          </>
        ) : (
          <>
            <h6 className='text-danger'>
              <span style={{ color: 'red', marginRight: '10px' }}>X</span>
              User is <strong>NOT AUTHENTICATED</strong>
            </h6>
            <div style={{ marginLeft: '30px', marginTop: '10px' }}>
              <small className='text-muted'>
                No active authentication session found. User needs to sign in.
              </small>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

AuthenticationStatus.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  email: PropTypes.string,
  name: PropTypes.string,
  accountId: PropTypes.string,
  environment: PropTypes.string,
};

export default AuthenticationStatus;
